var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.4624V20.5024C3 20.7824 3.21944 21.0024 3.49872 21.0024H6.53096C6.66063 21.0024 6.79029 20.9524 6.88006 20.8524L17.7722 9.94244L14.0318 6.19244L3.14962 17.1024C3.04987 17.2024 3 17.3224 3 17.4624ZM20.6648 7.04244C20.7572 6.94993 20.8306 6.84004 20.8806 6.71907C20.9307 6.59809 20.9565 6.46841 20.9565 6.33744C20.9565 6.20648 20.9307 6.07679 20.8806 5.95582C20.8306 5.83485 20.7572 5.72496 20.6648 5.63244L18.3307 3.29244C18.2385 3.19974 18.1289 3.12619 18.0082 3.07601C17.8875 3.02583 17.7582 3 17.6275 3C17.4969 3 17.3676 3.02583 17.2469 3.07601C17.1262 3.12619 17.0166 3.19974 16.9243 3.29244L15.099 5.12244L18.8394 8.87244L20.6648 7.04244Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.3c5e7880e89a3c5d6ec662e3ea355502.svg";
export { ForwardRef as ReactComponent };